<!-- Modal -->
<div class="modal fade" id="loginModal" tabindex="-1" role="dialog" aria-labelledby="loginModalLabel"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <!--Content-->
    <div class="modal-content form-elegant">
      <!--Header-->
      <div class="modal-header text-center">
        <h3 class="modal-title w-100 dark-grey-text font-weight-bold my-3" id="loginModalLabel"><strong>Iniciar sesión</strong></h3>
        <button #hideButton type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <!--Body-->
      <div class="modal-body mx-4">
        <!--Body-->
        <div class="md-form mb-5">
          <input [(ngModel)]="auth.email" type="email" id="Form-email1" class="form-control validate">
          <label data-error="wrong" data-success="right" for="Form-email1">Email</label>
        </div>

        <div class="md-form pb-3">
          <input [(ngModel)]="auth.password" type="password" id="Form-pass1" class="form-control validate">
          <label data-error="wrong" data-success="right" for="Form-pass1">Contraseña</label>
          </div>

        <div class="text-center mb-3">
          <button type="button" class="btn blue-gradient btn-block btn-rounded z-depth-1a" (click)='auth.login()'>Login</button>
        </div>
        <p class="font-small dark-grey-text text-right d-flex justify-content-center mb-3 pt-2"> o iniciar sesión con:</p>

        <div class="row my-3 d-flex justify-content-center">
          <!--Google +-->
          <button type="button" class="btn btn-white btn-rounded z-depth-1a" (click)="auth.glogin()" ><img src="assets/google-icon.png" class="fab fa-google-plus-g" width="30" height="30"></button>
        </div>
      </div>
      <!--Footer-->
      <div class="modal-footer mx-5 pt-3 mb-1">
        <p class="font-small grey-text d-flex justify-content-end">No eres miembro? <a routerLink="/registro" (click)="hide()" class="blue-text ml-1">
            Regístrate</a></p>
      </div>
    </div>
    <!--/.Content-->
  </div>
</div>
<!-- Modal -->

<div class="text-center" style="visibility: hidden; position: relative; height: 0;">
  <a #showButton href="" class="btn btn-default btn-rounded" data-toggle="modal" data-target="#loginModal" >Launch
    modal Login Form</a>
</div>
